"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgSwitcherArrow(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 37"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "M0 1v35h2.43a1 1 0 00.913-.593l7.562-16.987L3.347 1.59A1 1 0 002.435 1H0zm0-1h2.435a2 2 0 011.824 1.18L12 18.419 4.257 35.813A2 2 0 012.43 37H0V0z"
  }));
}

var MemoSvgSwitcherArrow = /*#__PURE__*/React.memo(SvgSwitcherArrow);
var _default = MemoSvgSwitcherArrow;
exports["default"] = _default;